import * as React from 'react';
import { TextField as MuiTextField } from '@mui/material';
import { TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField';
import { helperTextValid, helperTextWarning, textFieldRoot } from 'ui/TextField/textFieldCssDefs';

export interface TextFieldProps
  extends Pick<MuiTextFieldProps, Exclude<keyof MuiTextFieldProps, 'variant'>> {
  warn?: boolean;
  valid?: boolean;
}
/**
 * Use `TextField` for rendering a text field or text area with autosizing
 * [Material-ui TextField](https://mui.com/material-ui/react-text-field/)
 *
 * ```js
 * import { TextField } from 'ui';
 * ```
 *
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
const TextField: React.FunctionComponent<React.PropsWithChildren<TextFieldProps>> = ({
  warn,
  valid,
  value,
  defaultValue,
  name,
  ...rest
}) => {
  // Prevent both value and defaultValue from being passed simultaneously
  // Controlled (value) takes precedence over uncontrolled (defaultValue)
  const inputProps =
    value !== undefined ? { value } : defaultValue !== undefined ? { defaultValue } : {};

  return (
    <MuiTextField
      css={[textFieldRoot, warn && helperTextWarning, valid && helperTextValid]}
      FormHelperTextProps={{
        'aria-live': 'polite',
      }}
      variant="outlined"
      name={name}
      {...inputProps}
      {...rest}
    />
  );
};

export default TextField;
